import { render, staticRenderFns } from "./VxTextArea.vue?vue&type=template&id=845fcd00&lang=html&"
import script from "./VxTextArea.vue?vue&type=script&lang=js&"
export * from "./VxTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports